import { Sparkle } from '../ui/Icons';

const ITEMS = [
  'Manufacturing since 2007',
  'Best Water-Based Paint Manufacturer — PaintVision Awards',
  '1,800+ shades through Colour Mode',
  'Low-odour interior finishes',
  'Monsoon-tested exterior systems',
  'Waterproofing from roof to foundation',
  'Made in Khanna, Punjab',
  'Technical data sheet for every product',
];

/** Continuous brand-message ticker. Content is duplicated so the loop is seamless. */
const BrandTicker = ({ tone = 'navy' }: { tone?: 'navy' | 'gold' }) => {
  const dark = tone === 'navy';
  return (
    <div className={`relative overflow-hidden py-4 ${dark ? 'bg-brand-navy text-white' : 'bg-brand-gold text-brand-ink'}`} aria-label="Vertex Paints highlights">
      <div className="flex w-max vp-marquee hover:[animation-play-state:paused]">
        {[0, 1].map((copy) => (
          <ul key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {ITEMS.map((t) => (
              <li key={t} className="flex items-center gap-4 px-6 text-sm sm:text-[15px] font-semibold whitespace-nowrap">
                <Sparkle size={14} className={dark ? 'text-brand-gold' : 'text-brand-red'} />
                {t}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
};

export default BrandTicker;
